import Parser from './Parser';
import encodeChars from './rules/encodeChars';

export const getLayersData = (originalObject, nameIsKey = false) => {
  const result = {};
  Object.entries(originalObject?.groups || {}).forEach(([, groupValue]) => {
    if (groupValue.subgroups) {
      Object.entries(groupValue.subgroups).forEach(([, subgroupValue]) => {
        if (+subgroupValue.jurisdiction_filter === 1) {
          result[encodeChars.spaces(groupValue.group, true)] = {
            layerKey: groupValue.group,
            groupKey: groupValue.group,
            subgroupKey: subgroupValue.subgroup,
          };
          return;
        }

        if (subgroupValue.layers) {
          Object.entries(subgroupValue.layers).forEach(([key, value]) => {
            result[nameIsKey ? encodeChars.spaces(value.layer_title || key, true) : value.id] = {
              ...value,
              layerKey: value.layer_title || key,
              groupKey: groupValue.group,
              subgroupKey: subgroupValue.subgroup,
            };
          });
        }
      });
    }
  });

  return result;
};

export const parseLayers = (originalLayersObject, layers) => {
  if (!originalLayersObject?.groups || !layers) {
    return [{}];
  }
  const mappedData = getLayersData(originalLayersObject, true);
  const result = {};
  const landUseLayers = {};
  layers.split('.').forEach((item) => {
    const layer = mappedData[item];
    if (!layer) {
      return;
    }

    if (layer.groupKey === layer.layerKey) {
      landUseLayers[layer.layerKey] = true;
      return;
    }

    if (!result[layer.groupKey]) {
      result[layer.groupKey] = {};
    }

    if (!result[layer.groupKey][layer.subgroupKey]) {
      result[layer.groupKey][layer.subgroupKey] = [];
    }

    result[layer.groupKey][layer.subgroupKey].push(
      layer.layer_type !== 'tile' ? layer.layer_id : layer.tile_id,
    );
  });

  return [result, landUseLayers];
};

export default class LayersParser extends Parser {
  parseToUrl(data, layersData) {
    if (layersData) {
      const mappedData = getLayersData(layersData);
      const arrayData = Object.entries(data)
        .map(([key, item]) => {
          const encodedKey = encodeChars.spaces(key, true);
          return mappedData[encodedKey]
            ? encodedKey
            : Object.values(item)
              .flat()
              .filter(layer => !mappedData[layer]?.layer_enabled);
        })
        .flat(2);

      const result = arrayData
        .map(item => encodeChars.spaces(mappedData[item].layerKey, true))
        .join('.');

      this.data = {layers: result};
    }

    return this;
  }

  parseToData(url) {
    const params = url.split('&').map(param => param.split('='));
    const layersParam = params.find(param => param[0] === 'layers');
    this.data = layersParam ? {[layersParam[0]]: layersParam[1]} : {};

    return this;
  }
}
